module.exports = __webpack_public_path__ + "static/deltai-d796cf47a09660143f8427f4e44cd63b.svg";